<template>
	<div class="master-table" id="scroll-table" v-bar="{scrollThrottle: 30,draggerThrottle: 4}">
		<scroll-sync group="one" ref="verticalscrollset" vertical>
			<scroll-sync group="two" vertical>
				<table-loader v-if="isLoadingMoreRows"></table-loader>
				<!-- Added horizontal scroll -->

				<table class="relation-table">
					<template v-for="(relation, index) in relations">
						<relation-row :key="index" :relation="relation" :index="index" ref="relationRow"></relation-row>
					</template>
				</table>
				<div class="no-item" v-if="relations.length < 1">No items found !</div>
			</scroll-sync>
		</scroll-sync>
	</div>
</template>

<script>
const TableLoader = () => import("../../../common/TableLoader");
const { observer } = require("vue-mutation-observer");
const RelationRow = () => import("./RelationRow");
import settings from "../../../../config/settings";

export default {
  name: "Relation",
  components: { TableLoader, RelationRow },
  directives: { observer },
  data: () => {
    return {
      initScroll: false,
      dummyTest: {},
      loaderClass: "",
      loaderClassToggle: false,
      busy: false,
      loadMore: true
    };
  },
  computed: {
    /**
     * Get all relations from store
     */
    relations: function() {
      return this.$store.state.forecast.users;
    },
    /**
     * Flag value to check if more forecast rows are fetching
     */
    isLoadingMoreRows: function() {
      return this.$store.state.forecast.loadingMoreRows;
    }
  },
  methods: {
    /**
     * Update the loader class on all the component loads
     */
    updateLoader: function() {
      setTimeout(() => {
        if (
          typeof this.$refs.relationRow !== "undefined" &&
          this.$refs.relationRow.length === this.relations.length
        ) {
          this.loaderClass = "master-table-loaded";
          //For testing purpose
          this.loaderClassToggle = true;
          document
            .getElementById("scroll-table")
            .classList.add("master-table-loaded");
        }
      }, 200);
    },
    /**
     * Load more forecast data
     */
    loadMoreResults: function() {
      if (this.loadMore) {
        this.loadMore = false;
        this.$store.dispatch("fetchMoreForecast").then(() => {
          this.loadMore = true;
        });
      }
    },

    /**
     * Handle scrolling event on the relation div
     */
    handleScroll: function() {
      // get the parent element
      let parent = document.getElementById("scroll-table");
      // get the child element having scroll
      let child = parent.getElementsByClassName("scroll-sync-container");
      // get the first child, first having the scroll
      let firstChild = child[0];
      // get the client height of the first child
      let clientHeight = firstChild.clientHeight;
      // on scrolling the child
      firstChild.addEventListener("scroll", () => {
        // get the scroll height
        let height = firstChild.scrollHeight - firstChild.scrollTop;
        // scrolled down
        if (height <= clientHeight) {
          // load more data
          this.loadMoreResults();
        }
      });
    },
    /**
     * Remove the scroll event listener
     */
    removeEventListener: function() {
      let parent = document.getElementById("scroll-table");
      if (parent) {
        let child = parent.getElementsByClassName("scroll-sync-container");
        child[0].removeEventListener("scroll", () => {}, false);
      }
    },

    /* Custom horizontal scroll function when resizing the page to laptop or tab view */
    customHorizontalbar: function() {
      let oldy = 0;
      //Fixed width

      //Get scrollable div
      // let parentScrollElement = this.$refs.verticalscrollset.$el;
      let parentScrollElement;
      if(this.$refs.verticalscrollset.$el != null && this.$refs.verticalscrollset.$el != undefined){
        parentScrollElement = this.$refs.verticalscrollset.$el;
     }
     
     if (parentScrollElement != null && parentScrollElement != undefined) {
        let customScrollElement = parentScrollElement.querySelector(
          ".scroll-sync-container"
        );
        customScrollElement.classList.add("qtime-h-scroll");
        /*Now, <div class="scroll-sync-container qtime-h-scroll"></div> is the scrollable div */

        let customScrollElementWidth = customScrollElement.getBoundingClientRect(),
          customScrollElementRemainWidth = 0;

        //Create div and scroll panel for the scrollable div
        let scrollableFnWrap = document.createElement("div");
        scrollableFnWrap.id = "qtime-h-scroll-bar";
        scrollableFnWrap.classList.add("qtime-h-scroll-bar-class");
        customScrollElement.appendChild(scrollableFnWrap);

        //Create scroll thumb and append it into the  `scrollableFnWrap` div
        let scrollableThumb = document.createElement("div");
        scrollableThumb.id = "q-time-scroll-thumb";
        //scrollableThumb.setAttribute('draggable', true);
        scrollableFnWrap.appendChild(scrollableThumb);

        //setting thumb width, using thumb width function
        setTimeout(function() {
          thumbWidthFn();
        }, 500);

        //Thumb scroll event, used mousedown, mouseup and mousemove.
        scrollableThumb.onmousedown = function(e) {
          let shiftX = e.clientX - scrollableThumb.getBoundingClientRect().left;
          moveAt(e.pageX, e.pageY);
          oldy = e.pageY;

          //Move function, it scrolls the area.
          function moveAt(pageX) {
            customScrollElement.scrollLeft = pageX - shiftX;
            scrollableThumb.style.transform =
              "translateX(" + customScrollElement.scrollLeft + "px)";
          }

          //EventLintener trigger function
          function onMouseMove(e) {
            moveAt(e.pageX, e.pageY);
          }

          //Mouse move event
          document.addEventListener("mousemove", onMouseMove);

          //Mouseup event, after scolling and once the mouse is up, set the position and points.
          document.addEventListener("mouseup", () => {
            document.removeEventListener("mousemove", onMouseMove);
          });
        };

        // Horizontal scroll support event method.
        scrollableThumb.ondragstart = function() {
          return false;
        };

        //Call the method when resize event happens.
        customScrollElement.addEventListener("scroll", function(e) {
          SyncScrollDrag(e);
        });

        // Sync scroll, Both area scroll and thumb scroll should sync.
        function SyncScrollDrag() {
          scrollableThumb.style.transform =
            "translateX(" + customScrollElement.scrollLeft + "px)";
        }

        //Thumb width function
        function thumbWidthFn() {
          if (customScrollElement.scrollWidth >= 692) {
            //Remaining width
            customScrollElementRemainWidth =
              customScrollElement.scrollWidth - customScrollElementWidth.width;
            //adding thumb size as per screen size & scrollWidth calculation
            scrollableThumb.style.width =
              customScrollElementWidth.width -
              customScrollElementRemainWidth +
              "px";
          }

          // For small screens (< 900)
          if (customScrollElementWidth.width < 692) {
            scrollableThumb.style.width =
              (customScrollElement.scrollWidth -
                customScrollElementWidth.width) /
                10 +
              "px";
          }
        }
      }
    },

    //Remove scrollbar and thumb as init function.
    //to avoid duplication when resizing
    clearAllElements: function() {
      try {
        // let clearingNavBar = document.getElementById('qtime-h-scroll-bar');
        let clearingNavBar = document.querySelectorAll(
          ".qtime-h-scroll-bar-class"
        );
        clearingNavBar.forEach(i => {
          i.remove();
        });
      } catch (e) {
        console.log(e);
      }
    },
    
    callListeners: function(){
        this.clearAllElements();
        
        // this.customHorizontalbar();
    },
    
    //To close the header once the component is updated
    closeHeaderOption: function(){
      document.querySelector('.report-header-options').classList.remove('r-open');
    }
    
  },
  updated() {
    this.updateLoader();
    //To close the header once the component is updated
    this.closeHeaderOption();
    
  },
  created() {
    this.updateLoader();
  },
  mounted() {
    this.handleScroll();
    //Relation scroll when resizing
    let scrollElement = this.$refs.verticalscrollset.$el;
    let overflowContainer = scrollElement.querySelector(
      ".scroll-sync-container"
    );
    let scrollElementHead = document.querySelector(".master-t-head-b");

    //Sync scroll in laptop view
    overflowContainer.addEventListener("scroll", function(node) {
      scrollElementHead.scrollLeft = node.target.scrollLeft;
    });

    //sync scroll in laptop view
    scrollElementHead.addEventListener("scroll", function(node) {
      overflowContainer.scrollLeft = node.target.scrollLeft;
    });

    setTimeout(() => {
      // this.customHorizontalbar();
    }, 800);

    window.addEventListener("resize", this.callListeners);
  },
  beforeDestroy() {
    this.removeEventListener();
    window.removeEventListener("resize", this.callListeners);
  }
};
</script>

<style scoped>
	.loading-label {
		position: absolute;
		bottom: 30px;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		-moz-transform: translateX(-50%);
		width: 210px;
		height: 40px;
		background: rgb(247, 183, 49);
		border-radius: 10px;
		display: flex;
		display: -webkit-flex;
		display: -moz-flex;
		align-items: center;
		-webkit-align-items: center;
		-moz-align-items: center;
		justify-content: center;
		-webkit-justify-content: center;
		-moz-justify-content: center;
		color: #ffffff;
		box-shadow: 0px 2px 7px 0px #7a7a7a57;
		-webkit-box-shadow: 0px 2px 7px 0px #7a7a7a57;
		-moz-box-shadow: 0px 2px 7px 0px #7a7a7a57;
	}

	.relation-table-container-set {
		height: 471px;
		width: 100%;
	}

	/* Master page on relation */
	.master-table {
		border-bottom: 1px solid #dee1e3;
		max-height: calc(100vh - 300px);
		min-height: calc(100vh - 300px);
		height: calc(100vh - 300px);
	}
  
  
    @media screen and (max-width: 1440px){
      .master-table {
        border-bottom: 1px solid #dee1e3;
        max-height: calc(100vh - 320px);
        min-height: calc(100vh - 320px);
        height: calc(100vh - 320px);
      }
    }
  
</style>
 